import React from 'react';
import ReactModal from 'react-modal';
import ReactTooltip from 'react-tooltip';
import language from '@language';
import { termsCo } from './terms-co';

ReactModal.setAppElement('body');

export default class Form extends React.Component<any, any> {
    constructor(props) {
        super(props);
        const { initValues } = this.props;
        this.state = {
            fields: initValues
        };
    }

    handleChange(event) {
        const fieldName = event.target.name;
        const fieldValue = event.target.value;
        const { fields } = this.props;

        let newFields = {
            ...fields,
            [fieldName]: fieldValue
        };

        if (['conditions'].indexOf(fieldName) !== -1) {
            newFields = {
                ...newFields,
                conditions: !fields.conditions
            };
        }

        this.props.onChange(newFields);
    }

    handleFileInput(event) {
        const fieldName = event.target.name;
        const fieldValue = event.target.files[0];
        const { fields } = this.props;

        let newFields = {
            ...fields,
            [fieldName]: fieldValue
        };
        this.props.onChange(newFields);
    }

    handleSubmit(e) {
        e.preventDefault();
        this.props.onSubmit(this.props.fields);
    }

    showTerms(e) {
        e.preventDefault();
        this.setState({ showModal: true });
    }

    handleCloseModal() {
        this.setState({ showModal: false });
    }

    getTerms() {
        return { __html: termsCo };
    }

    render() {
        const { showModal } = this.state;
        const { errors, sending, showValidations, errorMessage, banks, dlocalBanks, fields } = this.props;

        return (
            <div className="bank-transfer pse">
                {sending && (
                    <div className="overlay">
                        <div className="loader" />
                    </div>
                )}
                {errorMessage && (
                    <div id="error-box" className="error-box">
                        <p>{errorMessage}</p>
                    </div>
                )}

                <form
                    id="dd-form"
                    onSubmit={e => this.handleSubmit(e)}
                    className={`${showValidations ? 'sended' : ''}`}
                >
                    <div className="row-input">
                        {/*client_number*/}
                        <div className={`input ${errors['client_number'] ? 'invalid' : ''}`}>
                            <label>{language.client_number}</label>
                            <input
                                name="client_number"
                                type="text"
                                value={fields.client_number}
                                onChange={e => this.handleChange(e)}
                                maxLength={8}
                            />
                            {errors['client_number'] && <div className="error-tooltip">{errors['client_number']}</div>}
                        </div>

                        {/*property_number*/}
                        <div className={`input ${errors['property_name'] ? 'invalid' : ''}`}>
                            <label>{language.property_name}</label>
                            <input name="property_name" type="text" onChange={e => this.handleChange(e)} />
                        </div>
                    </div>

                    <div className="row-input">
                        {/*holder_name*/}
                        <div className={`input ${errors['holder_name'] ? 'invalid' : ''}`}>
                            <label>{language.holder_name}</label>
                            <input
                                value={fields.holder_name}
                                name="holder_name"
                                type="text"
                                onChange={e => this.handleChange(e)}
                            />
                        </div>

                        {/*cuil*/}
                        <div className={`input ${errors['document'] ? 'invalid' : ''}`}>
                            <label>{language.document}</label>
                            <input
                                value={fields.document}
                                name="document"
                                type="text"
                                onChange={e => this.handleChange(e)}
                            />

                            {errors['document'] && <div className="error-tooltip">{errors['document']}</div>}
                        </div>
                    </div>

                    <div className="row-input">
                        {/*email*/}
                        <div className={`input ${errors['email'] ? 'invalid' : ''}`}>
                            <label>{language.email}</label>
                            <input
                                value={fields['email']}
                                name="email"
                                type="text"
                                onChange={e => this.handleChange(e)}
                            />
                        </div>
                    </div>

                    <div className="row-input">
                        {/*invoice_number*/}
                        <div className={`input ${errors['invoice_number'] ? 'invalid' : ''}`}>
                            <ReactTooltip id="invoice_number" place="top" type="dark" effect="solid">
                                <span>{language.invoice_disclaimer}</span>
                            </ReactTooltip>
                            <label>
                                <span>
                                    {language.invoice_number} <a className="info" data-tip data-for="invoice_number" />
                                </span>
                            </label>
                            <input
                                value={fields['invoice_number']}
                                name="invoice_number"
                                type="text"
                                onChange={e => this.handleChange(e)}
                                maxLength={109}
                            />

                            {errors['invoice_number'] && (
                                <div className="error-tooltip">{errors['invoice_number']}</div>
                            )}
                        </div>

                        {/*amount*/}
                        <div className={`input ${errors['amount'] ? 'invalid' : ''}`}>
                            <label>{language.amount}</label>

                            <div className="group">
                                <span className="symbol">$</span>
                                <input
                                    value={fields['amount']}
                                    className="small"
                                    name="amount"
                                    maxLength={15}
                                    type="text"
                                    onChange={e => this.handleChange(e)}
                                />
                            </div>
                            {errors['amount'] && <div className="error-tooltip">{errors['amount']}</div>}
                        </div>

                        <div className="row-input">
                            <div className="conditions">
                                <label>
                                    <input type="checkbox" onChange={e => this.handleChange(e)} name="conditions" />{' '}
                                    {language.terms_1}{' '}
                                    <a onClick={e => this.showTerms(e)} href="#">
                                        {language.terms_2}
                                    </a>
                                </label>
                                <ReactModal
                                    isOpen={showModal}
                                    contentLabel="Minimal Modal Example"
                                    className="terms_modal"
                                >
                                    <div dangerouslySetInnerHTML={this.getTerms()} />
                                    <button onClick={this.handleCloseModal}>{language.close}</button>
                                </ReactModal>
                            </div>
                        </div>
                    </div>

                    <div className="submit">
                        <button type="submit">{language.send}</button>
                    </div>
                </form>
            </div>
        );
    }
}
